import { useState } from "react";
import { NavLink } from "react-router-dom";
import classNames from "classnames";
import { useTranslate } from "../../../language/i18n";
import pages from "../../../utils/pages";
import { Home, Menu } from "../../../assets/icons";
import styles from "./MobileMenu.module.scss";
import MenuDrawer from "./MenuDrawer/MenuDrawer";
import { useAppSelector } from "../../../app/hooks";
import { selectSessionId } from "../../../features/session/sessionSelectors";

function MobileMenu() {
  const translate = useTranslate();
  const userLoggedIn = !!useAppSelector(selectSessionId);
  const [menuVisible, setMenuVisible] = useState(false);

  const onItemClick: Parameters<NavLink>[0]["onClick"] = () => {
    menuVisible && toggleDrawer();
  };

  const toggleDrawer = () => {
    setMenuVisible(menuVisible => !menuVisible);
  };

  return (
    <>
      {userLoggedIn && (
        <>
          <section className={styles.menu}>
            <NavLink
              exact
              to={pages.HOME}
              className={styles.link}
              activeClassName={styles.active}
              onClick={onItemClick}
            >
              <Home />
              <span className={styles.text}>{translate("HOME")}</span>
            </NavLink>

            <button
              className={classNames(styles.link, menuVisible && styles.active)}
              onClick={e => {
                e.preventDefault();
                toggleDrawer();
              }}
            >
              <Menu />
              <span className={styles.text}>{translate("MENU")}</span>
            </button>
          </section>

          <MenuDrawer visible={menuVisible} onMenuLinkClick={toggleDrawer} />
        </>
      )}
    </>
  );
}

export default MobileMenu;
